<template>
  <ion-content fullscreen class="swiper-content-crer bg-white-main" v-if="swipVisible">
    <swiper :modules="modules" :slides-per-view="1" :space-between="50" :pagination="{ clickable: true }"
      @swiper="onSwiper" @slideChange="onSlideChange" class="w-full h-full ion-padding">
      <swiper-slide>
        <div class="flex flex-column justify-center items-center ion-padding can-animate" id="animate">
          <div class="">
            <img src="/assets/images/call_room_fulllogo.png" alt="logo" class="logo-img" />
           <!--
            <div class="slogan text-grey" id="animate-after">
              Atletica
              <div class="mybold">
                Emilia Romagna
              </div>
            </div>
            -->
          </div>
        </div>
      </swiper-slide>
      <!---
      <swiper-slide>
        <div class="wrapper">
          <div class="wrapper-text flex flex-column justify-center items-center ion-padding">
            <div class="text-container">
              <div class="title bold text-blue">Profilo atleta digitale</div>
              <div class="subtitle text-grey">
                Riceverai una notifica per ogni iscrizione
                e per gli aggiornamenti degli orari direttamente nell'app di CallRoom.
              </div>
            </div>
          </div>
          <div class="wrapper-img">
            <img src="/assets/images/slide-3.png" alt="illustrazione iscrizioni" class="" />
          </div>
        </div>
      </swiper-slide>
      -->
      <swiper-slide>
        <div class="wrapper">
          <div class="wrapper-text flex flex-column justify-center items-center ion-padding">
            <div class="text-container">
              <div class="title bold text-blue">Trova gli eventi</div>
              <div class="subtitle text-grey">
                Cerca la tua prossima gara in base alle tue esigenze: grazie a CallRoom potrai cercare per gara, fascia
                oraria,
                numero di corsie della pista e tanto altro.
              </div>
            </div>
          </div>
          <div class="wrapper-img">
            <img src="/assets/images/slide-1.png" alt="illustrazione iscrizioni" class="" />
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="wrapper">
          <div class="wrapper-text flex flex-column justify-center items-center ion-padding">
            <div class="text-container">
              <div class="title bold text-blue">Tutti gli impianti</div>
              <div class="subtitle text-grey">
                Scopri dove e quando puoi allenarti: su CallRoom troverai tutti gli impianti in regione dove poter fare
                atletica con indicati gli orari di apertura, la presenza di parcheggio e altre informazioni utili.
              </div>
            </div>
          </div>
          <div class="wrapper-img">
            <img src="/assets/images/slide-2.png" alt="illustrazione iscrizioni" class="" />
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="wrapper">
          <div class="wrapper-text flex flex-column justify-center items-center ion-padding">
            <div class="text-container">
              <div class="title bold text-blue enter-callroom">Scegli la tua regione</div>
              <div class="subtitle text-grey">
                Seleziona la tua regione per iniziare a cercare le gare e gli impianti di atletica vicino a te.
              </div>
              <ion-radio-group v-if="selectedScope" @ionChange="setScope($event)"
                :value="scopes.find(s => s.pk === selectedScope.pk)">
                <ion-radio v-for="s in scopes" :key="s.pk" :value="s"
                  :class="['flex', 'flex-row', 'justify-between', 'items-center']">
                  {{ s.description }}
                </ion-radio>
              </ion-radio-group>
            </div>
          </div>
          <div class="wrapper-img">
            <img :src="getScopeImage" alt="illustrazione iscrizioni" />
          </div>
        </div>
      </swiper-slide>

      <swiper-slide>
        <div class="flex flex-column justify-center items-center ion-padding">
          <div class="">
            <div class="title bold text-blue enter-callroom">Entra in CallRoom!</div>
            <div class="subtitle text-grey">
              Noi siamo pronti, e tu?
            </div>
            <div class="wrapper-cta" @click="setSkipSwiper()">
              <ion-icon class="cta" :icon="chevronForwardCircleOutline" />
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </ion-content>
</template>
<script>
import { defineComponent, ref, computed, onMounted } from 'vue';
import { Autoplay, EffectFade, Keyboard, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { IonContent } from '@ionic/vue'
import { chevronForwardCircleOutline } from 'ionicons/icons';
import { IonIcon, IonRadio, IonRadioGroup } from '@ionic/vue';
import Storage from '@/models/Storage';
import { eventBus } from '@/config/eventBus.ts';


import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/keyboard';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/zoom';
import '@ionic/vue/css/ionic-swiper.css';

const sendScopeSelected = (scope) => {
  eventBus.emit("scopeSelected", scope);
  console.log(scope);
};



export default defineComponent({
  components: { IonContent, Swiper, SwiperSlide, IonIcon, IonRadio, IonRadioGroup },
  setup(props, { emit }) {
    const scopes = ref(Storage.get('scopes-list')?.filter((s) =>
      s.model_name === 'Area' && (!s.parent_scope || s.parent_scope === 'Italia')
    ) || []);

    const selectedScope = ref(Storage.get('scope') || scopes.value[0]);

    const getScopeImage = computed(() => {
      switch (selectedScope.value?.file_code) {
        case 'EMI': return '/assets/images/slide-5.1.png';
        case 'LOM': return '/assets/images/slide-5.2.png';
        default: return '/assets/images/slide-5.png';
      }
    });

    const slides = ref([
      { title: 'Profilo atleta digitale', subtitle: 'Riceverai una notifica per ogni iscrizione...', img: '/assets/images/slide-3.png', alt: 'illustrazione iscrizioni' },
      { title: 'Trova gli eventi', subtitle: 'Cerca la tua prossima gara...', img: '/assets/images/slide-1.png', alt: 'illustrazione iscrizioni' },
      { title: 'Tutti gli impianti', subtitle: 'Scopri dove e quando puoi allenarti...', img: '/assets/images/slide-2.png', alt: 'illustrazione impianti' }
    ]);

    const setScope = (event) => {
      Storage.set('scope', event.detail.value);
      selectedScope.value = event.detail.value;
      sendScopeSelected(selectedScope.value);
      emit('scope-selected', selectedScope);
    };

    onMounted(() => {
      setTimeout(() => document.getElementById("animate")?.classList.add("start-animate"), 3000);
      setTimeout(() => document.getElementById("animate-after")?.classList.add("start-animate"), 3500);
    });

    return {
      scopes,
      selectedScope,
      slides,
      getScopeImage,
      setScope,
      modules: [Autoplay, EffectFade, Keyboard, Pagination],
      chevronForwardCircleOutline
    };
  },
  data() {
    return {
      swipVisible: true
    }
  },
  mounted() {
    setTimeout(() => {
      let animate = document.getElementById("animate")
      animate?.classList.add("start-animate")
    }, 3000)
    setTimeout(() => {
      let animate = document.getElementById("animate-after")
      animate?.classList.add("start-animate")
    }, 3500)
  },
  methods: {
    setSkipSwiper() {
      this.swipVisible = false
      this.$emit('onCloseSwiper')
    }
  }
});
</script>


<style scoped>
ion-radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
  width: 60%;
  margin-left: auto;
  margin-right: auto;
}

ion-radio {
  font-size: 0.9em;
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: var(--ion-color-medium);
}

ion-radio::part(container) {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #ddd;
}

ion-radio::part(mark) {
  background: none;
  transition: none;
  transform: none;
  border-radius: 0;
}

ion-radio.radio-checked::part(container) {
  background: var(--ion-color-primary);
  border-color: transparent;
}

ion-radio.radio-checked::part(mark) {
  width: 6px;
  height: 10px;
  border-width: 0px 2px 2px 0px;
  border-style: solid;
  border-color: #fff;
  transform: rotate(45deg);
}

.can-animate .slogan {
  opacity: 0 !important;
  font-size: 1em;
  transition: all .5s;
  height: 0;
}

.can-animate .slogan.start-animate {
  opacity: 1 !important;
}

.start-animate.can-animate .slogan {
  height: 60px;
}

.can-animate .logo-img {
  margin-bottom: 0px;
  margin-left: auto;
  margin-right: auto;
  transition: margin .5s;
}

.start-animate.can-animate .logo-img {
  margin-bottom: 60px;
}

.first-space {
  margin-top: 60px !important;
}

.mybold {
  font-weight: 800;
}

.swiper-content-crer .bg-white-main {
  background-color: #f3f5f6;
}

.swiper-content-crer .text-grey {
  color: rgba(0, 0, 0, .7);
}

.swiper-content-crer .text-light-blue {
  color: #cdddfc;
}

.swiper-content-crer .bigger-title {
  font-size: 35pt;
  text-transform: uppercase;
}

.swiper-content-crer .title {
  font-size: 24pt;
  text-transform: uppercase;
  line-height: 40px;
}

.swiper-content-crer .subtitle {
  opacity: .8;
  font-size: 13pt;
  margin-top: 20px;
}

.swiper-content-crer .bold {
  font-weight: bold;
}

.swiper-content-crer .logo-img {
  height: 150px;
  width: auto;
}

.swiper-content-crer .illustration-img {
  margin-top: 30px;
  max-width: 350px;
}

.wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
}

.wrapper .wrapper-text {
  width: 100%;
  height: 50vh;
  flex: 1;
  padding: 3em 0;
}

.text-container {
  max-width: 550px;
  margin: 0 auto;
}

.wrapper .wrapper-img {
  padding: 0 2em;
  flex: 1;
  height: 50vh;
}

.swiper .swiper-slide .wrapper .wrapper-img img {
  display: block;
  margin: 0 auto;
  width: 100%;
  max-width: 450px;
}

.enter-callroom {
  line-height: 52px;
}

.wrapper-cta {
  margin-top: 3em;
}

ion-icon.cta {
  font-size: 3em;
  opacity: .3;
}



img.logo {
  height: 32px;
  width: auto;
}

.logo {
  font-weight: 900;
  font-size: 1.4em;
  letter-spacing: .05em;
}

.logo .c1 {
  color: var(--ion-color-primary);
}

.logo .c2 {
  color: #cdddfc;
}
</style>